import { ActionMenu } from "@telluscompany/design-system";
import { Edit, Trash2, MoreVertical } from "lucide-react";
import { useLocalization } from "@i18n";
import type { ListStructuresResponse } from "../../api/structures/structures.types";

interface StructuresActionMenuProps {
  structure: ListStructuresResponse;
  onEdit: (structure: ListStructuresResponse) => void;
  onDelete: (structure: ListStructuresResponse) => void;
}

export const StructuresActionMenu = ({
  structure,
  onEdit,
  onDelete,
}: StructuresActionMenuProps) => {
  const { translate } = useLocalization();

  const actions = [
    {
      actions: [
        {
          label: translate("management.structures.button.edit"),
          onClick: () => onEdit(structure),
          icon: <Edit size={16} />,
        },
        {
          label: translate("management.structures.button.delete"),
          onClick: () => onDelete(structure),
          icon: <Trash2 size={16} />,
          colorTitle: "red" as const,
        },
      ],
    },
  ];

  return <ActionMenu menu={actions} trigger={<MoreVertical size={20} />} />;
};
